import { render } from "./PanelView.vue?vue&type=template&id=ebe3e53a&scoped=true"
import script from "./PanelView.vue?vue&type=script&lang=js"
export * from "./PanelView.vue?vue&type=script&lang=js"

import "./PanelView.vue?vue&type=style&index=0&id=ebe3e53a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe3e53a"]])

export default __exports__